<section class="section proyects" id='proyects'>
    <div class="container">
      <div class="section-box">
        <div data-aos="fade-up" data-aos-duration="1000">
          <h3 class="section-title">
            <span class='n-section-title'>03.</span> {{"FeatureProjects.Title" | translate}}
          </h3>
        </div>
  
        <div *ngFor='let project of "FeatureProjects.Projects" | translate' class="d-flex proyect-container" data-aos="fade-up" data-aos-duration="1000">
          
          <!-- Text on the left -->
          <div class="proyect-info-left h-100" style="background-image: url('{{project.img}}');">
            <div class="proyect-box">
              <h4 class="feature-proyect text-left">{{"FeatureProjects.Label" | translate}}</h4>
              <h5 class="proyect-name text-left">{{project.Title}}</h5>
  
              <div class="proyect-description-box" (click)='debug()'>
                <p class="mb-0" [innerHTML]="project.Description"></p>
              </div>
  
              <ul class="proyect-skills justify-content-start">
                <li *ngFor='let technology of project.Technologies' class="ml-3">
                  <span class="underline technology">{{technology}}</span>
                </li>
              </ul>
   
              <div class="proyect-links text-left">
                <a   style='color: inherit' [href]="project['ghLink']" target="_blank">
                  <i class="ml-3 fab fa-github"></i>
                </a>
                <a style='color: inherit' [href]="project['demoLink']" target="_blank">
                    <i class="ml-3 fas fa-external-link-alt"></i>
                </a>
              </div>
            </div>
          </div>
          
          <!-- Image Carousel or Static Image on the right -->
          <owl-carousel-o class='owl-carousel-o' [options]="customOptions">
            <ng-container *ngFor="let img of project.imgs">
              <ng-template carouselSlide [id]="project.Title+slide">
                <div class='img-container' (click)="handleImageClick(project.Title)">
                  <img class='img-feature-proyect rounded' [src]="img" [alt]="project.Title">
                </div>
              </ng-template>
            </ng-container>
          </owl-carousel-o>
  
          <!-- Static main image (optional) -->
          <div class="img-feature-proyect-container" data-aos="fade-up" data-aos-duration="1000">
            <div class="img-feature-proyect-box">
              <div class="img-container" style='width: auto;' (click)="handleImageClick(project.Title)">
                <img class='img-feature-proyect rounded' [src]="project.imgs[0]" [alt]="project.imgs[0]" width='600px'>
              </div>
            </div>
          </div>
  
        </div>
  
      </div>
    </div>
  </section>
  